import { render } from "./ContactSection.vue?vue&type=template&id=63d3a5aa&scoped=true"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"

import "./ContactSection.vue?vue&type=style&index=0&id=63d3a5aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d3a5aa"]])

export default __exports__